import React, { MouseEvent, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'grommet';
import { Performance } from 'grommet-icons';

import ConfirmModal from 'src/components/ConfirmModal';
import { resetSessions } from 'src/reducers/workSessions/workSessionsReducer';
import { PATHS } from 'src/constants/paths';

type DropAlign = {
  top?: 'top' | 'bottom';
  bottom?: 'top' | 'bottom';
  left?: 'right' | 'left';
  right?: 'right' | 'left';
};

const MENU_DROP_ALIGN: DropAlign = { top: 'bottom', right: 'right' };

function SettingsMenu(): JSX.Element {
  const dispatch = useDispatch();
  const [isShowConfirm, setIsShowConfirm] = useState(false);
  const hideConfirm = useCallback(() => {
    setIsShowConfirm(false);
  }, []);
  const showConfirm = useCallback(() => {
    setIsShowConfirm(true);
  }, []);
  const handleResetSessions = useCallback(() => {
    dispatch(resetSessions());
    hideConfirm();
  }, [dispatch, hideConfirm]);
  const navigate = useNavigate();
  const handleLogout = useCallback(
    (event: MouseEvent<HTMLButtonElement> | MouseEvent<HTMLAnchorElement>) => {
      if (event.ctrlKey || event.metaKey) {
        return;
      }

      event.preventDefault();
      navigate(PATHS.LOGOUT);
    },
    [navigate]
  );

  const menuItems = useMemo(
    () => [
      { label: 'Reset sessions', onClick: showConfirm },
      {
        label: 'Logout',
        href: PATHS.LOGOUT,
        onClick: handleLogout,
      },
    ],
    [showConfirm, handleLogout]
  );

  return (
    <>
      <Menu items={menuItems} dropAlign={MENU_DROP_ALIGN} icon={<Performance />} plain />
      <ConfirmModal onConfirm={handleResetSessions} onCancel={hideConfirm} isShow={isShowConfirm}>
        Do you really want to reset work sessions?
      </ConfirmModal>
    </>
  );
}

export default SettingsMenu;
